import React from 'react'
import FlexView from 'react-flexview/lib'
import { FirebaseService, FirebaseConfigKey } from '../../../../services/FirebaseService'
import { PolicyDroneView } from '../../../Core/Hull/PolicyDroneView'
import { PolicyEquipmentView } from '../../../Core/Hull/PolicyEquipmentView'
import { HullPopover } from '../../../Core/Popover/HullPopover'

interface DronesAndEquipmentProps {
    onModify: Function,
    insuredDrones: Drone[],
    insuredEquipment: Equipment[]
}

export const DronesAndEquipment = ({insuredDrones,insuredEquipment}: DronesAndEquipmentProps) => {
    
    return (
        <React.Fragment>
            <FlexView marginTop={15} className="space-between margin-bottom-basic">
                <div className="text-body bold black">{FirebaseService.getValue(FirebaseConfigKey.HULL_HEADER_TEXT)}<HullPopover/></div>
            </FlexView> 
            {insuredDrones.map((drone, index) => <div key={index} className="margin-top-basic"><PolicyDroneView  drone={drone} dronePremium={drone.premium} droneDeductible={drone.value * drone.deductibleRate/100} /></div>)}
            {insuredEquipment.map((equipment, index) => <div key={index} className="margin-top-basic"><PolicyEquipmentView  equipment={equipment} equipmentPremium={equipment.premium} equipmentDeductible={equipment.value * equipment.deductibleRate/100}/></div>)}

        </React.Fragment>
    )
}